export const tradeByBrokersLocation = "/reports/exchbusiness/turnoverbrokers";
